import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class TabViewSwitchService {
  @Output() tabViewSwitched = new EventEmitter();

  public invokeTabViewSwitched(fromTabViewId, dataWithTabViewId) {
    if (fromTabViewId !== dataWithTabViewId.tabViewId) {
      this.tabViewSwitched.emit();
    }
  }
}
